<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="width: 600px;">
            <el-form-item label="账号" prop="account">
                <el-input v-model="form.account" placeholder="请输入角色名称"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入角色名称"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入角色编码" autocomplete="new-tel"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input type="password" v-model="form.password" placeholder="请输入密码" show-password
                    autocomplete="new-password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="password2">
                <el-input type="password" v-model="form.password2" placeholder="请再次输入密码" show-password></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="roleId">
                <el-select v-model="form.roleId">
                    <el-option v-for="item in roles" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-switch v-model="form.status"></el-switch>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, edit, detail } from "@/api/permission/admin";
import { list } from "@/api/permission/role";
export default {
    data() {
        const validatePass2 = (rule, value, callback) => {
            if (value !== this.form.password) {
                callback(new Error('两次输入的密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            id: null,
            roles: [],
            form: {
                account: "",
                name: "",
                phone: "",
                password: "",
                password2: "",
                roleId: "",
                status: true,
            },
            password: "",
            rules: {
                account: [{ required: true, message: '请输入账号' }],
                name: [{ required: true, message: '请输入姓名' }],
                phone: [{ required: true, message: '请输入手机号' }],
                password: [{ required: true, message: '请输入密码' }],
                password2: [{ required: true, message: '请输入确认密码' }, { validator: validatePass2, trigger: 'blur' }],
                roleId: [{ required: true, message: '请选择角色' }]
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        if (this.id) {
            this.getDetail();
        }
        this.getRoles();
    },
    methods: {
        getRoles() {
            list().then(({ code, data, message }) => {
                if (code == 200) {
                    this.roles = data;
                } else {
                    this.$message.error(message);
                }
            })
        },
        getDetail() {
            detail(this.id).then(({ code, data }) => {
                if (code == 200) {
                    this.form = {
                        account: data.account,
                        name: data.name,
                        phone: data.phone,
                        roleId: +data.roleId,
                        status: data.status == 1 ? true : false,
                        password: data.password,
                        password2: data.password
                    };
                    this.password = data.password;
                }
            })
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    status: this.form.status ? 1 : 0,
                }
                delete params.password2;
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>